import React, { useRef } from "react";
import Row from "./Row";
import { toPng } from "html-to-image";
import styled from "styled-components";

const StyledDrawingPanel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledPixels = styled.div`
  margin-bottom: 2rem;
`;

export default function DrawingPanel(props) {
  const { width, height, selectedColor } = props;

  const panelRef = useRef();

  const rows = [];

  for (let i = 0; i < height; i++) {
    rows.push(<Row key={i} width={width} selectedColor={selectedColor} />);
  }

  const htmlToImageConvert = () => {
    toPng(panelRef.current, { cacheBust: false })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = "art.png";
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <StyledDrawingPanel>
      <StyledPixels ref={panelRef}>{rows}</StyledPixels>
      <button onClick={htmlToImageConvert} className="button">
        Export as PNG
      </button>
    </StyledDrawingPanel>
  );
}
